import { Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

type Props = {
  handleOpenDialog: () => void;
  title: string;
  buttonText: string;
  children?: React.ReactNode;
};

const BordMegementHeader = ({
  handleOpenDialog,
  title,
  buttonText,
  children,
}: Props) => {
  return (
    <div className="flex flex-col items-start justify-between gap-4 mb-6 sm:flex-row sm:items-center">
      <h5 className="text-2xl font-semibold text-[#6E7B8B]">{title}</h5>

      <div className="flex items-center gap-2">
        {/* Upload / Export buttons will come here */}
        {children}

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenDialog}
          sx={{
            bgcolor: "#5BC0BE",
            "&:hover": { bgcolor: "#49a9a7" },
            textTransform: "none",
          }}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default BordMegementHeader;